<div class="container">
  <app-header-actions [headerTitle]="'INTERACTIONS.TITLE'" [headerIcon]="faChartLine" [config]="headerConfig"
    [initialFilters]="currentFilters"
    [count]="totalItems + ' ' + ('INTERACTIONS.TITLE' | translate)" [showCount]="true"
    (addClick)="onAddInteraction()" (filtersChanged)="onFiltersChanged($event)" (searchCleared)="onSearchCleared()"
    (tagFilterCleared)="onTagFilterCleared()" (allFiltersCleared)="onAllFiltersCleared()"></app-header-actions>

  <app-item-list [items]="interactionsAsListItems" [loading]="loading" [config]="listConfig"
    (itemClick)="onItemClick($event)" (actionClick)="onItemAction($event)" (itemClick)="onItemClick($event)"
    (tagClick)="tagManager.openTagDescription($event)"></app-item-list>

  <app-pagination [currentPage]="currentPage" [totalPages]="totalPages" [totalItems]="totalItems" [pageSize]="pageSize"
    (pageChange)="onPageChange($event)"></app-pagination>

  <app-modal-create-interaction [show]="showCreateModal" (close)="onModalClose()"
    (created)="onModalCreated()"></app-modal-create-interaction>

  <app-modal-delete-confirm [show]="showDeleteModal" [configKey]="interactionToDelete?.name || ''"
    [configType]="'INTERACTIONS.TITLE' | translate" [impactItems]="interactionImpactItems" (close)="onDeleteClose()"
    (confirm)="onDeleteConfirm()"></app-modal-delete-confirm>

  <app-modal-rename-confirm [show]="showRenameModal" [loading]="renaming"
    [itemName]="interactionToRename?.name || ''" [initialValue]="interactionToRename?.name || ''"
    (close)="onRenameClose()" (confirm)="onRenameConfirm($event)"></app-modal-rename-confirm>

  <app-tag-manager #tagManager [entityType]="tagEntityType" [entityName]="'INTERACTIONS.TITLE' | translate"
    (tagChanged)="onTagChanged()">
  </app-tag-manager>
</div>